import React, { useEffect, useState } from 'react';
import CustomGrid from '../CustomGrid';
import GridConfig from './gridConfig';
import { constructShipmentsStatusBar, getShipmentsData } from '../../../utils';
import { withStyles } from '@material-ui/core';
import { autorun } from 'mobx';
import ValidationReason from '../../ValidationReason';

const styles = (theme) => ({
  container: {
    minWidth: 400,
    width: '50%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  }
});

const LGtrailerRequired = ({ classes, data, IBPlanningStore, currentStepMessage }) => {
  const [shipments, setShipments] = useState([]);

  useEffect(() => {
    const dispose = autorun(populateShipmentsData);
    return () => dispose(); // Cleanup autorun on unmount
  }, [data]); // Re-run when `data` reference changes

  const populateShipmentsData = () => {
    if (data) {
      const shipmentsData = getShipmentsData({
        proIdList: data,
        shipmentsList: IBPlanningStore.shipmentsList
      });
      setShipments(shipmentsData);
    }
  };

  return (
    <div className={classes.container}>
      <ValidationReason message={currentStepMessage} />
      <CustomGrid
        title="Shipments"
        GridConfig={GridConfig}
        data={shipments}
        showSearchBar
        constructStatusBar={constructShipmentsStatusBar}
      />
    </div>
  );
};

export default withStyles(styles)(LGtrailerRequired);
